export default __webpack_public_path__ + "static/media/NUGGET.f35627d8.svg";